// docs for router https://github.com/thepassle/app-tools/blob/master/router/README.md

import { html } from 'lit';

if (!(globalThis as any).URLPattern) {
  await import("urlpattern-polyfill");
}

import { Router } from '@thepassle/app-tools/router.js';
import { lazy } from '@thepassle/app-tools/router/plugins/lazy.js';

// @ts-ignore
import { title } from '@thepassle/app-tools/router/plugins/title.js';

const baseURL: string = (import.meta as any).env.BASE_URL;

// Import components
import './pages/app-home/app-home.js';
import './pages/app-map/app-map.js';
import './pages/app-settings/app-settings.js';
import './pages/app-aurora/app-aurora.js';

// Create and export the router instance
export const router = new Router({
  routes: [
    {
      path: resolveRouterPath(),
      title: 'Map',
      plugins: [
        lazy(() => import('./pages/app-map/app-map.js'))
      ],
      render: () => html`<app-map></app-map>`
    },
    {
      path: resolveRouterPath('nowcast'),
      title: 'Nowcast',
      plugins: [
        lazy(() => import('./pages/app-home/app-home.js'))
      ],
      render: () => html`<app-home></app-home>`
    },
    {
      path: resolveRouterPath('settings'),
      title: 'Settings',
      plugins: [
        lazy(() => import('./pages/app-settings/app-settings.js'))
      ],
      render: () => html`<app-settings></app-settings>`
    },
    {
      path: resolveRouterPath('aurora'),
      title: 'Aurora',
      plugins: [
        lazy(() => import('./pages/app-aurora/app-aurora.js'))
      ],
      render: () => html`<app-aurora></app-aurora>`
    }
  ]
});

// This function will resolve a path with whatever Base URL was passed to the vite build process.
// Use of this function throughout the starter is not required, but highly recommended, especially if you plan to use GitHub Pages to deploy.
// If no arg is passed to this function, it will return the base URL.
export function resolveRouterPath(unresolvedPath?: string) {
  var resolvedPath = baseURL;
  if(unresolvedPath) {
    resolvedPath = resolvedPath + unresolvedPath;
  }

  return resolvedPath;
}